import { $ as jquery } from 'jquery';

var $ = jquery;

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.jquery = window.layui.jquery || $;
  window.$ = window.$ || $;
  window.jQuery = window.jQuery || $;
}

var tagsinput = (function () {
  (function ($) {
    var INSTANCE_KEY = 'layui.tagsinput.instance';
    var NS_KEY = 'layui.tagsinput.namespace';
    var DEFAULTS = {
      interactive: true,
      defaultText: 'add a tag',
      minChars: 0,
      width: '300px',
      height: '100px',
      autocomplete: { selectFirst: false },
      hide: true,
      delimiter: ',',
      unique: true,
      removeWithBackspace: true,
      placeholderColor: '#666666',
      autosize: true,
      comfortZone: 20,
      inputPadding: 12,
    };
    var uniqueIdCounter = 0;

    function trimText(value) {
      return value == null ? '' : String(value).trim();
    }

    function ensureId($input) {
      var id = $input.attr('id');
      if (!id) {
        id = 'tags' + Date.now() + uniqueIdCounter++;
        $input.attr('id', id);
      }
      return id;
    }

    function toDelimiterArray(delimiter) {
      return Array.isArray(delimiter) ? delimiter : [delimiter];
    }

    function splitTags(value, delimiter) {
      var source = trimText(value);
      if (!source) {
        return [];
      }
      var delimiters = toDelimiterArray(delimiter).filter(Boolean);
      if (!delimiters.length) {
        return [source];
      }
      var pattern = new RegExp(
        delimiters
          .map(function (item) {
            return String(item).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          })
          .join('|'),
      );
      return source
        .split(pattern)
        .map(trimText)
        .filter(Boolean);
    }

    function getInstance(target) {
      return $(target).data(INSTANCE_KEY) || null;
    }

    function destroyInstance(target) {
      var instance = getInstance(target);
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy();
      }
    }

    function setRealValue($realInput, tags, delimiter) {
      $realInput.val(tags.join(Array.isArray(delimiter) ? delimiter[0] || ',' : delimiter));
    }

    function createTagNode(instance, value) {
      return $('<span>')
        .addClass('tag')
        .attr('data-tag-value', value)
        .append(
          $('<span>').text(value).append('\u00a0\u00a0'),
          $('<a>', {
            href: '#',
            title: 'Removing tag',
            text: 'x',
          }).on('click' + instance.ns, function (event) {
            event.preventDefault();
            instance.removeTag(value, true);
            return false;
          }),
        );
    }

    function TagsInput(element, options) {
      this.$realInput = $(element);
      this.id = ensureId(this.$realInput);
      this.ns = '.tagsinput_' + Math.random().toString(36).slice(2, 10);
      this.settings = $.extend(true, {}, DEFAULTS, options || {});
      this.tags = [];
      this.autocompleteMode = null;
      this.dom = {
        holder: null,
        inputWrapper: null,
        fakeInput: null,
      };
      this.init();
    }

    TagsInput.prototype.init = function () {
      this.destroyMarkup();
      if (this.settings.hide) {
        this.$realInput.hide();
      }
      this.build();
      this.bind();
      this.importTags(this.$realInput.val(), false);
      this.$realInput.data(INSTANCE_KEY, this);
      this.$realInput.attr('data-tagsinput-init', 'true');
      this.$realInput.data(NS_KEY, this.ns);
    };

    TagsInput.prototype.build = function () {
      var holderId = this.id + '_tagsinput';
      var inputWrapperId = this.id + '_addTag';
      var fakeInputId = this.id + '_tag';
      var markup =
        '<div id="' +
        holderId +
        '" class="tagsinput"><div id="' +
        inputWrapperId +
        '">';

      if (this.settings.interactive) {
        markup +=
          '<input id="' +
          fakeInputId +
          '" value="" data-default="' +
          this.escapeAttr(this.settings.defaultText) +
          '" />';
      }

      markup += '</div><div class="tags_clear"></div></div>';

      $(markup).insertAfter(this.$realInput[0]);

      this.dom.holder = $('#' + holderId);
      this.dom.inputWrapper = $('#' + inputWrapperId);
      this.dom.fakeInput = this.settings.interactive ? $('#' + fakeInputId) : $();

      this.dom.holder.css('width', this.settings.width);
      this.dom.holder.css('min-height', this.settings.height);
      this.dom.holder.css('height', this.settings.height);

      if (this.settings.interactive) {
        this.dom.fakeInput.val(this.settings.defaultText).css('color', this.settings.placeholderColor);
        this.resetAutosize();
      }
    };

    TagsInput.prototype.bind = function () {
      var instance = this;
      var fakeInput = this.dom.fakeInput;
      if (!this.settings.interactive) {
        return;
      }

      this.dom.holder.on('click' + this.ns, function () {
        fakeInput.trigger('focus');
      });

      fakeInput.on('focus' + this.ns, function () {
        if (fakeInput.val() === fakeInput.attr('data-default')) {
          fakeInput.val('');
        }
        fakeInput.css('color', '#000000');
      });

      if (this.settings.autocomplete_url !== undefined) {
        this.bindAutocomplete();
      } else {
        fakeInput.on('blur' + this.ns, function () {
          instance.handleBlur();
          return false;
        });
      }

      fakeInput.on('keypress' + this.ns, function (event) {
        if (instance.checkDelimiter(event)) {
          event.preventDefault();
          instance.commitInputTag(true);
          instance.resetAutosize();
          return false;
        }
        if (instance.settings.autosize) {
          instance.doAutosize();
        }
        return undefined;
      });

      if (this.settings.removeWithBackspace) {
        fakeInput.on('keydown' + this.ns, function (event) {
          if (event.keyCode === 8 && fakeInput.val() === '') {
            event.preventDefault();
            instance.removeLastTag();
            fakeInput.trigger('focus');
          }
        });
      }

      fakeInput.on('paste' + this.ns, function () {
        setTimeout(function () {
          instance.handlePaste();
        }, 0);
      });

      if (this.settings.unique) {
        fakeInput.on('keydown' + this.ns, function (event) {
          if (event.keyCode === 8 || String.fromCharCode(event.which || 0).match(/\w+|[áéíóúÁÉÍÓÚñÑ,/]+/)) {
            fakeInput.removeClass('not_valid');
          }
        });
      }

      fakeInput.trigger('blur');
    };

    TagsInput.prototype.bindAutocomplete = function () {
      var instance = this;
      var fakeInput = this.dom.fakeInput;
      var autocompleteOptions = { source: this.settings.autocomplete_url };
      var attrname;

      for (attrname in this.settings.autocomplete) {
        if (Object.prototype.hasOwnProperty.call(this.settings.autocomplete, attrname)) {
          autocompleteOptions[attrname] = this.settings.autocomplete[attrname];
        }
      }

      if ($.Autocompleter !== undefined) {
        this.autocompleteMode = 'legacy';
        fakeInput.autocomplete(this.settings.autocomplete_url, this.settings.autocomplete);
        fakeInput.on('result' + this.ns, function (event, data) {
          if (data) {
            instance.addTag(String(data[0]), { focus: true, unique: instance.settings.unique });
          }
        });
      } else if ($.ui && $.ui.autocomplete !== undefined) {
        this.autocompleteMode = 'jquery-ui';
        fakeInput.autocomplete(autocompleteOptions);
        fakeInput.on('autocompleteselect' + this.ns, function (event, ui) {
          instance.addTag(ui.item.value, { focus: true, unique: instance.settings.unique });
          return false;
        });
      } else {
        fakeInput.on('blur' + this.ns, function () {
          instance.handleBlur();
          return false;
        });
      }
    };

    TagsInput.prototype.doAutosize = function () {
      var input = this.dom.fakeInput;
      var minWidth = input.data('minwidth');
      var maxWidth = input.data('maxwidth');
      var value = input.val();
      var testSubject = $('#' + input.data('tester_id'));
      var escaped;
      var testerWidth;
      var newWidth;
      var currentWidth;
      var isValidWidthChange;

      if (!input.length || !testSubject.length) {
        return;
      }

      escaped = value.replace(/&/g, '&amp;').replace(/\s/g, ' ').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      testSubject.html(escaped);
      testerWidth = testSubject.width();
      newWidth = testerWidth + this.settings.comfortZone >= minWidth ? testerWidth + this.settings.comfortZone : minWidth;
      currentWidth = input.width();
      isValidWidthChange =
        (newWidth < currentWidth && newWidth >= minWidth) || (newWidth > minWidth && newWidth < maxWidth);

      if (isValidWidthChange) {
        input.width(newWidth);
      }
    };

    TagsInput.prototype.resetAutosize = function () {
      var input = this.dom.fakeInput;
      var minWidth;
      var maxWidth;
      var testerId;
      var testSubject;

      if (!input.length) {
        return;
      }

      minWidth = input.data('minwidth') || this.settings.minInputWidth || input.width();
      maxWidth =
        input.data('maxwidth') ||
        this.settings.maxInputWidth ||
        (input.closest('.tagsinput').width() - this.settings.inputPadding);
      testerId = input.attr('id') + '_autosize_tester';

      testSubject = $('#' + testerId);
      if (!testSubject.length) {
        testSubject = $('<tester/>')
          .attr('id', testerId)
          .css({
            position: 'absolute',
            top: -9999,
            left: -9999,
            width: 'auto',
            fontSize: input.css('fontSize'),
            fontFamily: input.css('fontFamily'),
            fontWeight: input.css('fontWeight'),
            letterSpacing: input.css('letterSpacing'),
            whiteSpace: 'nowrap',
          })
          .appendTo('body');
      }

      input.data('minwidth', minWidth);
      input.data('maxwidth', maxWidth);
      input.data('tester_id', testerId);
      input.css('width', minWidth);
    };

    TagsInput.prototype.escapeAttr = function (value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    };

    TagsInput.prototype.getTags = function () {
      return this.tags.slice();
    };

    TagsInput.prototype.tagExists = function (value) {
      return $.inArray(value, this.tags) >= 0;
    };

    TagsInput.prototype.addTag = function (value, options) {
      var settings = $.extend({ focus: false, callback: true, unique: this.settings.unique }, options || {});
      var normalized = trimText(value);
      var fakeInput = this.dom.fakeInput;

      if (!normalized) {
        return false;
      }

      if (settings.unique && this.tagExists(normalized)) {
        fakeInput.addClass('not_valid');
        return false;
      }

      this.tags.push(normalized);
      createTagNode(this, normalized).insertBefore(this.dom.inputWrapper);
      setRealValue(this.$realInput, this.tags, this.settings.delimiter);

      if (fakeInput.length) {
        fakeInput.val('');
        if (settings.focus) {
          fakeInput.trigger('focus');
        } else {
          fakeInput.trigger('blur');
        }
      }

      if (settings.callback && typeof this.settings.onAddTag === 'function') {
        this.settings.onAddTag.call(this.$realInput[0], normalized);
      }

      if (typeof this.settings.onChange === 'function') {
        this.settings.onChange.call(this.$realInput[0], this.$realInput, normalized);
      }

      return true;
    };

    TagsInput.prototype.removeTag = function (value, triggerCallback) {
      var normalized = trimText(unescape(value));
      var nextTags = [];
      var changed = false;
      var i;

      for (i = 0; i < this.tags.length; i++) {
        if (this.tags[i] === normalized) {
          changed = true;
          continue;
        }
        nextTags.push(this.tags[i]);
      }

      if (!changed) {
        return false;
      }

      this.tags = nextTags;
      this.renderTags();
      setRealValue(this.$realInput, this.tags, this.settings.delimiter);

      if (triggerCallback && typeof this.settings.onRemoveTag === 'function') {
        this.settings.onRemoveTag.call(this.$realInput[0], normalized);
      }

      if (typeof this.settings.onChange === 'function') {
        this.settings.onChange.call(this.$realInput[0], this.$realInput, normalized);
      }

      return true;
    };

    TagsInput.prototype.removeLastTag = function () {
      if (!this.tags.length) {
        return false;
      }
      return this.removeTag(this.tags[this.tags.length - 1], true);
    };

    TagsInput.prototype.renderTags = function () {
      var instance = this;
      this.dom.holder.find('.tag').remove();
      this.tags.forEach(function (tag) {
        createTagNode(instance, tag).insertBefore(instance.dom.inputWrapper);
      });
    };

    TagsInput.prototype.importTags = function (value, triggerChange) {
      var tags = splitTags(value, this.settings.delimiter);
      var i;

      this.tags = [];
      this.dom.holder.find('.tag').remove();
      this.$realInput.val('');

      for (i = 0; i < tags.length; i++) {
        this.addTag(tags[i], { focus: false, callback: false, unique: this.settings.unique });
      }

      if (triggerChange !== false && typeof this.settings.onChange === 'function') {
        this.settings.onChange.call(this.$realInput[0], this.$realInput[0], this.tags.slice());
      }
    };

    TagsInput.prototype.handleBlur = function () {
      var value = this.dom.fakeInput.val();
      var defaultText = this.dom.fakeInput.attr('data-default');

      if (value !== '' && value !== defaultText) {
        this.commitInputTag(true);
      } else {
        this.dom.fakeInput.val(defaultText).css('color', this.settings.placeholderColor);
      }
    };

    TagsInput.prototype.handlePaste = function () {
      var input = this.dom.fakeInput;
      var pastedText = input.val();
      var tags = splitTags(pastedText, this.settings.delimiter);
      var i;

      if (!pastedText || pastedText === input.attr('data-default')) {
        return;
      }

      for (i = 0; i < tags.length; i++) {
        if (this.isValidTagLength(tags[i])) {
          this.addTag(tags[i], { focus: false, unique: this.settings.unique });
        }
      }

      input.val('');
      this.resetAutosize();
      try {
        input.trigger('focus');
      } catch (e) {
        // Ignore focus failures.
      }
    };

    TagsInput.prototype.isValidTagLength = function (tag) {
      return (
        this.settings.minChars <= tag.length &&
        (!this.settings.maxChars || this.settings.maxChars >= tag.length)
      );
    };

    TagsInput.prototype.commitInputTag = function (focusAfterAdd) {
      var value = trimText(this.dom.fakeInput.val());
      if (this.isValidTagLength(value)) {
        this.addTag(value, { focus: focusAfterAdd, unique: this.settings.unique });
      } else {
        this.dom.fakeInput.val(this.dom.fakeInput.attr('data-default')).css('color', this.settings.placeholderColor);
      }
    };

    TagsInput.prototype.checkDelimiter = function (event) {
      var delimiters = toDelimiterArray(this.settings.delimiter);
      var found = false;

      if (event.which === 13) {
        return true;
      }

      $.each(delimiters, function (index, delimiter) {
        if (event.which === String(delimiter).charCodeAt(0)) {
          found = true;
        }
      });

      return found;
    };

    TagsInput.prototype.destroyAutocomplete = function () {
      var fakeInput = this.dom.fakeInput;
      if (!fakeInput.length) {
        return;
      }

      if (this.autocompleteMode === 'jquery-ui' && $.ui && $.ui.autocomplete !== undefined) {
        try {
          fakeInput.autocomplete('destroy');
        } catch (e) {
          // Ignore plugin destroy failures.
        }
      }
    };

    TagsInput.prototype.destroyMarkup = function () {
      $('#' + this.id + '_tagsinput').remove();
      $('#' + this.id + '_tag_autosize_tester').remove();
    };

    TagsInput.prototype.destroy = function () {
      this.destroyAutocomplete();
      if (this.dom.holder) {
        this.dom.holder.off(this.ns);
      }
      if (this.dom.fakeInput) {
        this.dom.fakeInput.off(this.ns);
      }
      this.$realInput.off(this.ns);
      this.destroyMarkup();
      this.$realInput.removeData(INSTANCE_KEY);
      this.$realInput.removeData(NS_KEY);
      this.$realInput.removeAttr('data-tagsinput-init');
      if (this.settings.hide) {
        this.$realInput.show();
      }
    };

    $.fn.addTag = function (value, options) {
      return this.each(function () {
        var instance = getInstance(this);
        if (instance) {
          instance.addTag(value, options);
        }
      });
    };

    $.fn.removeTag = function (value) {
      return this.each(function () {
        var instance = getInstance(this);
        if (instance) {
          instance.removeTag(value, true);
        }
      });
    };

    $.fn.tagExist = function (value) {
      var instance = getInstance(this[0]);
      return instance ? instance.tagExists(value) : false;
    };

    $.fn.importTags = function (value) {
      return this.each(function () {
        var instance = getInstance(this);
        if (instance) {
          instance.importTags(value, true);
        }
      });
    };

    $.fn.tagsInput = function (options) {
      return this.each(function () {
        destroyInstance(this);
        new TagsInput(this, options);
      });
    };

    $.fn.tagsInput.updateTagsField = function (obj, tagslist) {
      var instance = getInstance(obj);
      if (instance) {
        instance.tags = tagslist.slice();
        setRealValue(instance.$realInput, instance.tags, instance.settings.delimiter);
      }
    };

    $.fn.tagsInput.importTags = function (obj, value) {
      var instance = getInstance(obj);
      if (instance) {
        instance.importTags(value, true);
      }
    };
  })($);
  return $.fn.tagsInput;
})();

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.tagsinput = tagsinput;
  if (window.jQuery) {
    window.jQuery.fn.tagsInput = $.fn.tagsInput;
    window.jQuery.fn.tagsinput = $.fn.tagsInput;
  }
}

export { tagsinput };
